module.exports = __webpack_public_path__ + "starfish.14e89850a112482b581e37d10bef7101.hashedasset.svg";


//////////////////
// WEBPACK FOOTER
// ./app/img/users/starfish.svg
// module id = 6295633753907672
// module chunks = 1